export { ContentsService } from '../../services/contents.service';
export type { UrlKey } from '../../services/contents.service';
